/* eslint-disable max-len */
const translations =
{
  ActionCard: {
    details: 'Check work'
  },
  Button: {
    addCourseButton: '+ Add Grade Band'
  },
  Gradebook: {
    gradebookBR: 'Details'
  },
  GradebookActivityTable: {
    feedBack: 'Shoutout',
    firstName: 'First Name',
    grade: 'Grade',
    lastName: 'Last Name',
    status: 'Status',
    studentVersion: 'Student Version',
    submitted: 'Submitted'
  },
  GradebookTable: {
    feedBack: 'Shoutout'
  },
  LeaderBoardModal: {
    allRankedLeaderboardClassrooms: 'All Classes',
    allRankedLeaderboardSchools: 'All Schools',
    leaderboardBodyDescription: 'The Leaderboard prize will be awarded to the FIRST EmPowered class to reach the highest amount of points by April 22nd.',
    leaderboardFacultyScore: 'Points',
    leaderboardHeader: 'Leaderboard'
  },
  LeaderboardService: {
    unknownPoints: 'N/A',
    unknownRank: 'N/A'
  },
  ProgressView: {
    allRankedLeaderboardClassrooms: 'All Classes',
    allRankedLeaderboardSchools: 'All Schools',
    classroomProgress: 'Classroom Progress',
    leaderboardBodyDescription: 'The Leaderboard prize will be awarded to the FIRST EmPowered class to reach the highest amount of points by April 22nd.',
    leaderboardFacultyScore: 'Points',
    leaderboardHeader: 'Leaderboard',
    leaderboardPositionTitleMessage: 'Your position on the Leaderboard will appear when the LPL Admin approves your sent activities.',
    lessonProgress: 'Lesson Progress',
    lessonsComplete: 'Lessons Complete',
    topRankedLeaderboardClassrooms: 'Top 3 Classes',
    topRankedLeaderboardSchools: 'Top 3 Schools',
    viewAll: 'VIEW ALL'
  },
  StudentFeedbackModal: {
    feedBack: 'Shoutout'
  },
  TeacherFeedbackModal: {
    feedBack: 'Shoutout'
  }
};

export default translations;
